import { DataStates } from "../../../store/global/data-state";

const pathSeparator = '.';
const bookingOverview = (path) => `${path}`;
const cdate = (path) => `cdate${pathSeparator}${path}`;


// Green: #64C896
// Yellow: #E6DC64
// Red: #FF6E6E

export const checklist = [
  {
    text: 'Contracts',
    value: 'contracts',
    tkey: 'contracts',
    icon: 'contract/contact-active.svg',
    children: [
      {
        text: 'Contracts sent to promoter',
        name: 'contracts_out_flag',
        xpath: cdate('contracts_out_flag'),
        tkey: 'contracts_out',
        value: false,
        dataState: DataStates.LOADED,
        bc: '#E6DC64',
        signDate:""
      },
      {
        text: 'Contracts agreed',
        name: 'contracts_signed_flag',
        xpath: cdate('contracts_signed_flag'),
        tkey: 'contracts_signed',
        value: false,
        dataState: DataStates.LOADED,
        bc: '#64C896',
      },
    ],
    getIcon: function([contracts_out_flag, contracts_signed_flag]) {
      if (contracts_signed_flag.value) {
        return 'contract/contact-active.svg';
      } else if (contracts_out_flag.value) {
        return 'contract/contact-orange.svg';
      } else {
        return 'contract/contact-inactive.svg';
      }
    }
  },
  {
    text: 'Itinerary',
    value: 'itinerary',
    icon: 'itinerary/itinerary-orange.svg',
    tkey: 'riders',
    children: [
      {
        text: 'Questionnaire sent out',
        name: 'itinerary_promoter_flag',
        xpath: cdate('itinerary_promoter_flag'),
        tkey: 'itinerary_promoter',
        value: false,
        dataState: DataStates.LOADED,
        bc: '#FF6E6E',
      },
      {
        text: 'Questionnaire received',
        name: 'itinerary_info_flag',
        xpath: cdate('itinerary_info_flag'),
        tkey: 'itinerary_info',
        value: false,
        dataState: DataStates.LOADED,
        bc: '#E6DC64',
      },
      {
        text: 'Itinerary sent to Artist',
        name: 'itinerary_artist_flag',
        xpath: cdate('itinerary_artist_flag'),
        tkey: 'itinerary_artist',
        value: false,
        dataState: DataStates.LOADED,
        bc: '#64C896',
      }
    ],
    getIcon: function([itinerary_promoter_flag, itinerary_info_flag, itinerary_artist_flag]) {
      if (itinerary_artist_flag.value) {
        return 'itinerary/itinerary-active.svg';
      } else if (itinerary_info_flag.value) {
        return 'itinerary/itinerary-orange.svg';
      } else if (itinerary_promoter_flag.value) {
        return 'itinerary/itinerary-orange.svg';
      } else {
        return 'itinerary/itinerary-inactive.svg';
      }
    }
  },
  {
    text: 'Local Details',
    value: 'local_details',
    icon: 'localdetails/localdetails-inactive.svg',
    tkey: 'local_details',
    children: [
      {
        text: 'Local Details Confirmed	',
        name: 'local_details_confirmed_flag',
        xpath: cdate('local_details_confirmed_flag'),
        tkey: 'local_details_confirmed',
        value: false,
        dataState: DataStates.LOADED,
        bc: '#64C896',
      },
    ],
    getIcon: function([local_details_confirmed_flag]) {
      if (local_details_confirmed_flag.value) {
        return 'localdetails/localdetails-active.svg';
      } else {
        return 'localdetails/localdetails-inactive.svg';
      }
    }
  },
  {
    text: 'Travel Details',
    value: 'travel_details',
    icon: 'airplane/airplane-active.svg',
    tkey: 'travel_details',
    children: [
      {
        text: 'Travel Details Confirmed	',
        name: 'travel_detail_confirmed_flag',
        xpath: bookingOverview('travel_detail_confirmed_flag'),
        tkey: 'travel_details_confirmed',
        value: false,
        dataState: DataStates.LOADED,
        bc: '#64C896',
      },
    ],
    getIcon: function([travel_detail_confirmed_flag]) {
      if (travel_detail_confirmed_flag.value) {
        return 'airplane/airplane-active.svg';
      } else {
        return 'airplane/airplane-inactive.svg';
      }
    }
  },
  {
    text: 'Finance',
    value: 'finance',
    icon: 'finance/finance-active.svg',
    tkey: 'finance',
    children: [
      {
        text: 'Invoices confirmed	',
        name: 'invoices_out_flag',
        xpath: cdate('invoices_out_flag'),
        tkey: 'all_invoices_created',
        value: false,
        dataState: DataStates.LOADED,
        bc: '#64C896',
      },
    ],
    getIcon: function([invoices_out_flag], finance_status) {
      // if (invoices_out_flag.value) {
      //   return 'finance/finance-orange.svg';
      // } else {
      //   return 'finance/finance-inactive.svg';
      // }
      
      switch (finance_status) {
        case 'RED':
          return 'finance/finance-inactive.svg';
        case 'GREEN':
          return 'finance/finance-active.svg';
        case 'YELLOW':
          return 'finance/finance-orange.svg';    
        default:
          break;
      }
    }
  },
];

export const findCheckListGroupByItemName = (objList, name) => {
  console.log(objList);
  return objList.find(a => a.children.find(b => b.name === name));
}

export const findCheclistItemByName = (objList, name) => {
  const nameSelector = (name) => (b) => b.name === name;
  const childSelector = (name) => (a) => a.children.find(nameSelector(name));
  return objList.find(childSelector(name)).children.find(nameSelector(name));
}

// console.log(JSON.stringify(checklist, 0, 2));
